import { render, staticRenderFns } from "./filter_foto.vue?vue&type=template&id=6b8930c4&"
import script from "./filter_foto.vue?vue&type=script&lang=js&"
export * from "./filter_foto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports